import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import { Link } from 'react-router-dom'

function PageNotFound() {
    return (
        <div className=''>
            <Helmet>
                <title>Home - {utils.siteName}</title>
            </Helmet>
            <main className="flex-grow flex flex-col items-center justify-center px-6 py-12">
                <div className="max-w-7xl px-8 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-center">
                    <div className="relative group">
                        <div className="aspect-[4/5] rounded-lg overflow-hidden bg-surface-container-high transition-transform duration-700 ease-out group-hover:scale-[1.01]">
                            <img
                                alt="Serene interior with high-end minimal aesthetic"
                                className="w-full h-full object-cover"
                                src="https://lh3.googleusercontent.com/aida-public/AB6AXuCVEKXzbwj7i07insz-1vUmoCOcrtu_G0Dwr1hp6Bk85x0jHp6LeVEQEbmTU39UkoUb5ComCkCP8npU9k2gMsAAu5m9Yep4EEHNRM4Ot5f0SdMhqxAdrJsoGrTAVRGANq4TCsTD_pJxgbZooKz1iREKk7pb6xWmmDhy8ZjeKL7zlWcwr0L_fKZvfJW5AQGCugC_fS9RLCSrTOxwUPqNSer17TpaBSmpbTA9r4wupCRIMqeBnjNON1zpX3Rfwzu28jYE7o1_D_IqG0I" />
                        </div>
                        <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-secondary/5 rounded-full blur-2xl"></div>
                    </div>

                    <div className="flex flex-col space-y-10 text-center md:text-left">
                        <div className="space-y-6">
                            <div className="inline-block px-3 py-1 border border-outline-variant/30 rounded-full">
                                <span className="font-label text-[10px] tracking-[0.3em] uppercase text-on-surface-variant/70">Error 404 / Page Not Found</span>
                            </div>
                            <h1 className="font-headline text-4xl md:text-5xl lg:text-6xl text-primary leading-tight">
                                Lost in
                                <span className="italic font-light">Tranquility</span>
                            </h1>
                            <p className="font-body text-base md:text-lg text-on-surface-variant  md:mx-0 leading-relaxed opacity-80">
                                It seems the page you seek has found its own quiet corner. Let's return you to the heart of the estate.
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row items-center md:items-start gap-4">
                            <Link className="px-10 py-4 bg-secondary text-white rounded-lg font-body font-medium text-sm tracking-wide transition-all duration-300 hover:shadow-lg hover:shadow-secondary/20 hover:-translate-y-0.5 flex items-center gap-3" to="/">
                                <span>Back to Home</span>
                                <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </Link>
                        </div>

                        <div className="pt-8 border-t border-outline-variant/10 flex flex-wrap justify-center md:justify-start gap-x-8 gap-y-4">
                            <Link
                                className="font-label text-[10px] tracking-widest uppercase text-on-surface-variant hover:text-secondary transition-colors"
                                to="/houses">Amenities</Link>
                            <Link
                                className="font-label text-[10px] tracking-widest uppercase text-on-surface-variant hover:text-secondary transition-colors"
                                to="/contact">Contact</Link>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default PageNotFound